if (!customElements.get('estoria-review-actions')) {
  customElements.define('estoria-review-actions', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.button = this.querySelector('[data-helpful-toggle]');
      this.count = this.querySelector('[data-helpful-count]');
      this.note = this.querySelector('[data-helpful-note]');
      this.status = this.querySelector('[data-helpful-status]');
      if (!this.button || !this.count || !this.note || !this.status) return;
      this.button.disabled = true;
      const { productId, commentId, baseCount } = this.dataset;
      this.base = Number(baseCount);
      if (!productId || !commentId || !/^\d+$/.test(baseCount) || !Number.isSafeInteger(this.base)) return;
      const key = `estoria-helpful:${encodeURIComponent(productId)}:${encodeURIComponent(commentId)}`;
      if (this.key !== key) {
        this.key = key;
        this.voted = false;
        this.pageOnly = false;
      }
      this.readVote();
      this.render();
      this.button.disabled = false;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.button.addEventListener('click', () => this.toggle(), options);
      this.ownerDocument.defaultView.addEventListener('storage', event => {
        if (event.key !== null && event.key !== this.key) return;
        this.readVote();
        this.render();
      }, options);
    }

    readVote() {
      if (this.pageOnly) return;
      try {
        this.voted = this.ownerDocument.defaultView.localStorage.getItem(this.key) === '1';
      } catch {
        this.pageOnly = true;
      }
    }

    toggle() {
      if (this.button.disabled) return;
      this.readVote();
      this.voted = !this.voted;
      if (!this.pageOnly) {
        try {
          const storage = this.ownerDocument.defaultView.localStorage;
          if (this.voted) storage.setItem(this.key, '1');
          else storage.removeItem(this.key);
        } catch {
          this.pageOnly = true;
        }
      }
      this.render();
      this.status.textContent = this.pageOnly ? this.dataset.unavailableMessage
        : this.voted ? this.dataset.addedMessage : this.dataset.removedMessage;
    }

    render() {
      this.button.setAttribute('aria-pressed', String(this.voted));
      this.count.textContent = String(this.base + Number(this.voted));
      const message = this.pageOnly ? this.dataset.unavailableMessage : this.dataset.savedMessage;
      this.button.setAttribute('title', message);
      this.note.textContent = message;
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
